import { PlatformLocation } from '@angular/common';
import { Component, Input, Output, EventEmitter, OnInit, Inject, Injectable } from '@angular/core';
import { BLOCKS, INLINES, Document } from '@contentful/rich-text-types';
import { NodeRenderer, NodeRendererResolver } from 'ngx-contentful-rich-text';

// import { APP_BASE_HREF } from '@angular/common';

import { Location, LocationStrategy } from '@angular/common';


@Component({
  // template: `<a class="lcp-embedded-link" [href]="url">{{ display }}</a>`
  // [routerLink]="navItem.fields['link']"
  // routerLinkActive="is-active"
  template: `
      <span class="white-space-no-wrap">
        <a class="lcp-embedded-link"
          [attr.href]="url" 
          [attr.data-slug]="slug">
          {{ display }}
        </a>
        <span *ngIf="includeComma">,</span>
      </span>
    `
})
export class RichTextInternalLinkComponent extends NodeRenderer implements OnInit {
  
  fields: any
  link: string
  url: string
  display: string
  slug: string
  includeComma: boolean

  constructor(
    // @Inject(APP_BASE_HREF) baseHref: string
    // private location: Location,
    private locationStrategy: LocationStrategy,
    // private platformLocation: PlatformLocation,
  ) {
    super()
  }

  ngOnInit() {
    this.fields = this.node.data['target'].fields;
    this.link = this.fields['routerLink'] 
    if (this.link && this.link[0] == '/') this.link = this.link.slice(1)
    // this.url = APP_BASE_HREF + this.link
    let origin = window.location.origin
    let baseHref = this.locationStrategy.getBaseHref(); // this.platformLocation.getBaseHrefFromDOM();
    this.url = this.link && origin + baseHref + this.link
    // this.url.replace("//", "/")
    this.slug = this.fields['slug']
    this.includeComma = this.fields['includeComma']
    this.display = this.fields['display']
    // console.log('TODO: embedded-inline:', this.url, this.fields)


    // console.log('loc', this.location, this.location.origin);
    // console.log('ext-url', this.location.prepareExternalUrl('/'));
    // console.log('base-href', this.locationStrategy.getBaseHref());
  }
}


@Component({
  selector: 'lcp-rich-text',
  templateUrl: './rich-text.component.html',
  styleUrls: ['./rich-text.component.scss']
})
export class RichTextComponent implements OnInit {

  @Input('document') document: any
  // @Input('direction') direction: string = 'left'
  // @Output() onInit = new EventEmitter<any>()


  nodeRenderers: Record<string, NodeRendererResolver> = {
    [INLINES.EMBEDDED_ENTRY]: (node) => RichTextInternalLinkComponent
  };

  // constructor(@Inject(APP_BASE_HREF) baseHref: string) { }

  ngOnInit() {
    // this.update()
  }

  ngOnChanges() {
    // this.update()
  }

  
  // update () {
  //   this.isPaused = this.hoveringContainer || this.hoveringSlide
  //   // console.log('paused', this.isPaused)
  // }
  
}
